<div class="custom-answer" [ngClass]="{'has-delete': showDelete}">
  <div class="custom-answer__title">
    <input
      type="text"
      placeholder="Describe activity"
      class="form-control"
      [name]="uniqueDescriptionControlName"
      [id]="uniqueDescriptionId"
      [(ngModel)]="description"
      (ngModelChange)="onChange()"
      >
    </div>

    <div class="custom-answer__amount">
      <input
        type="text"
        placeholder="R 0"
        class="form-control"
        currencyMask
        [options]="maskOptions"
        [name]="uniqueValueControlName"
        [id]="uniqueValueId"
        [(ngModel)]="value"
        (ngModelChange)="onChange()"
        >
      </div>

      @if (showDelete) {
        <div class="custom-answer__delete">
          <a href="#" class="action-remove">
            <svg class="icon">
              <use xlink:href="#trash"></use>
            </svg>
          </a>
        </div>
      }
    </div>
